import EmploymentHistory from './EmploymentHistory';

export default EmploymentHistory;
